export const getRightId = (role: string): number => {
  switch (role) {
    case "Superuser":
      return 0;
    case "Admin":
      return 1;
    case "Editor":
      return 2;
    default:
      return 3;
  }
};
